"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarkersFromLayers = exports.setView = exports.invalidateSize = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
function invalidateSize(map) {
    setTimeout(() => {
        map.invalidateSize();
    }, 200);
}
exports.invalidateSize = invalidateSize;
function setView(map, location) {
    if (location.lat && location.lng && location.zoom) {
        map.setView([location.lat, location.lng], location.zoom);
    }
}
exports.setView = setView;
function getMarkersFromLayers(markers) {
    return [...markers.getLayers()].filter(layer => layer instanceof leaflet_1.default.Marker);
}
exports.getMarkersFromLayers = getMarkersFromLayers;
